import { PropsWithChildren, useEffect, useRef, useState } from 'react';
import { ScrollBodyProvider } from '@/contexts/ScrollBodyContext';

export const PageBody = ({ children }: PropsWithChildren) => {
  const viewportRef = useRef<HTMLDivElement>(null);
  const [viewportWidth, setViewportWidth] = useState<number | undefined>();

  useEffect(() => {
    // Initial width
    setViewportWidth(viewportRef.current?.clientWidth);
    // Create ResizeObserver to watch for size changes
    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setViewportWidth(entry.contentRect.width);
      }
    });

    if (viewportRef.current) {
      observer.observe(viewportRef.current);
    }

    // Cleanup
    return () => observer.disconnect();
  }, []);

  return (
    <ScrollBodyProvider viewportRef={viewportRef}>
      <div className="!relative h-full overflow-hidden">
        <div
          className="h-full w-full overflow-y-auto overflow-x-hidden rounded-[inherit] custom-scrollbar"
          ref={viewportRef}
        >
          <div style={{ minWidth: '100%', display: 'table', height: '100%' }}>
            <div
              className="h-full p-4"
              style={{
                width: viewportWidth,
              }}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </ScrollBodyProvider>
  );
};
